module.exports = __webpack_public_path__ + "img/param1.0552c306.png";